export default __webpack_public_path__ + "static/media/wifiActived.1b89728f.svg";